var _effectorFileName = "/src/features/quiz/components/quiz-result-header.tsx";
import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '@/shared/lib/cn';

// QuizResult компонент - основной контейнер для результата
interface QuizResultProps {
  className?: string;
  children?: React.ReactNode;
}
export const QuizResult = React.forwardRef<HTMLDivElement, QuizResultProps>(({
  className,
  children,
  ...props
}, ref) => {
  return <motion.div ref={ref} key="success-content" initial={{
    opacity: 0,
    scale: 0.95
  }} animate={{
    opacity: 1,
    scale: 1
  }} transition={{
    duration: 0.4,
    ease: [0.4, 0, 0.2, 1]
  }} className={cn('flex h-full flex-col items-center justify-center sm:min-w-[280px] md:min-w-[400px]', className)} {...props}>
        {children}
      </motion.div>;
});
QuizResult.displayName = 'QuizResult';